export default "__VITE_ASSET__lI4w3b4U__"